module.exports = __webpack_public_path__ + "img/事迹详情.82cfe090.png";